<template>
  <div :style="{'min-height':clientHeight+'px','background-color':'#F7F7F7'}" id="outermost">
    <van-nav-bar
      title="问题详情"
      left-text="返回"
      left-arrow
      @click-left="$router.back()"
      id="topbar"
    />

    <div  style="background-color:#FFFFFF;">
      <div class="problem">
        <div style="padding:0px 20px;border-bottom:1px solid #EBEEF5;">
          <div class="typeTxt">
            <span></span>
            {{ problem.problemSubclass }}
          </div>

          <van-row class="infoRow" align="center">
            <van-col>问题类型{{ problem.id }}：</van-col>
            <van-col>{{ problem.problemTypeName }}</van-col>
          </van-row>

          <van-row class="infoRow" align="center" v-if="problem.rectificationStatus!=4">
            <van-col>问题状态：</van-col>
            <van-col>{{ problem.rectificationStatus === '0' ? '未整改' : '已整改' }}</van-col>
          </van-row>

          <van-row class="infoRow" align="center" v-else>
            <van-col>问题状态：</van-col>
            <van-col>未提交</van-col>
          </van-row>

          <van-row class="infoRow">
            <van-col span="24" style="line-height:30px;">问题子类：</van-col>
            <van-col style="line-height:20px;">{{ problem.problemSubclass }}</van-col>
          </van-row>

          <van-row class="infoRow" align="center">
            <van-col>问题等级：</van-col>
            <van-col>{{ problem.levelName }}</van-col>
          </van-row>

          <van-row v-if="problem.problemDescription" class="infoRow">
            <van-col span="24" style="line-height:30px;">问题描述：</van-col>
            <van-col style="line-height:20px;">{{ problem.problemDescription }}</van-col>
          </van-row>
          <van-row v-else class="infoRow" align="center">
            <van-col>问题描述：</van-col>
            <van-col>无</van-col>
          </van-row>

          <van-row class="infoRow" align="center">
            <van-col>检查日期：</van-col>
            <van-col>{{ problem.inspectionDate }}</van-col>
          </van-row>

          <van-row class="infoRow" align="center">
            <van-col>整改期限：</van-col>
            <van-col>{{ problem.rectificationPeriod }}</van-col>
          </van-row>

          <van-row v-if="problem.problemPhotos" class="infoRow">
            <van-col span="24" style="line-height:30px;">现场照片：</van-col>
            <van-image v-for="(p, i) of problem.problemPhotos.split(',')" :key="i" :src="apiUrl + 'download/' + p"
                       width="60" height="60" @click="showSignPhoto(p)" style="margin-right: 10px"/>
          </van-row>


          <van-row v-else class="infoRow" align="center">
            <van-col>现场照片：</van-col>
            <van-col>无</van-col>
          </van-row>

        </div>
      </div>
    </div>


  </div>
</template>

<script>
import $ from '@/fly'
import Setting from '@/setting';
import Vue from 'vue';
import {ImagePreview} from 'vant';

Vue.use(ImagePreview);
export default {
  name: "problemDetail",
  data(){
    return{
      clientHeight: window.screen.height,
      problem:{},
      apiUrl: Setting.apiBaseURL,
    }
  },
  methods:{
    showSignPhoto(id) {
      ImagePreview({
        images: [
          Setting.apiBaseURL + 'download/' + id
        ],
        closeable: true
      });
    },
  },
  mounted() {
    this.problem = JSON.parse(localStorage.getItem('detailProblem'))
    console.log('problem======>',this.problem)
  }
}
</script>

<style scoped>
.van-search__content {
  border: 1px solid #8da0eb;
}

.problem {
  margin-bottom: 20px;
}

.typeTxt {
  font-size: 30px;
  font-weight: bold;
  border-bottom: 1px solid #EBEEF5;
  padding: 25px 0px 15px 0px;
  letter-spacing: 1px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.typeTxt span {
  width: 5px;
  background-color: #50C9FF;
  display: inline-block;
  height: 34px;
  vertical-align: middle;
}

.infoRow {
  padding: 20px 5px;
  font-size: 26px;
  font-weight: bold;
}

.infoRow .van-col:nth-child(1) {
  color: #999999;
}

.btnDiv {
  padding: 40px;
}

.btnDiv button {
  width: 100%;
  height: 60px;
  line-height: 60px;
  border-radius: 5px;
}
</style>
